module.exports = __webpack_public_path__ + "img/M7A0662-Enhanced.52e97240.jpg";